/* TOPローディング画面 */

// 関数定義
function customLoadingView() {
  // 変数宣言
  const body = document.body,
  loadingConteiner = document.querySelector(".loading__container"),
  iconHeader = document.querySelector(".c-icon-header");
  const mediaQuery = window.matchMedia('(max-width: 749px)');

  // ロード中に横スクロールバーを非表示にするclass
  body.classList.add('c-loading--is-loading')

  // アニメーション開始前の準備
  iconHeader.style.opacity = 0;

  // アニメーション関数
  function loadingAnimation() {

    // アニメーション本体の関数
    function fullLoadingAnimation() {
      loadingConteiner.style.pointerEvents = 'none'

      // タイムライン定義
      const tl = gsap.timeline({
        onComplete: () => {
          // アニメーション終了後の処理
          // custom-top.js内のキービジュアルスライダー関数にアクセス
          setTimeout(function(){
            mvSlideshow("start")
            iconHeader.style.opacity = 1;
            loadingConteiner.remove();
            body.classList.remove('c-loading--is-loading')
            body.classList.add('c-loading--is-loaded')
          }, 800)
        }
      })

      // 要素の初期値設定
      if (!mediaQuery.matches) {
        // PC
        tl
          .set('.c-header__side-fixed', {
            transform: 'translateX(-100%)'
          })
          .set('.c-slideshow .c-slideshow__info--wrapper',{
            opacity: 0,
          })
          .set('.c-slideshow__navigation', {
            opacity: 0,
          })
      } else {
        // SP
        tl
          .set('.c-slideshow__navigation', {
              opacity: 0,
          })
      }

      // タイムライン本体
      if (!mediaQuery.matches) {
        // PC
        tl
          .to('.loading__container',
            {
              duration: 1.2,
              opacity: 0,
              ease: "power1.inOut"
            },
          )
          .to('.c-header__side-fixed',
            {
              duration: 1.2,
              transform: 'translateX(0)',
              ease: "power2.inOut"
            },
            '<+0.6'
          )
          .to('.c-slideshow .c-slideshow__info--wrapper',
            {
              duration: 0.8,
              opacity: 1,
              ease: "power1.inOut"
            }
          )
          .to('.c-slideshow__navigation',
            {
              duration:0.8,
              opacity: 1,
              ease: "power1.inOut"
            },
            '<'
          )
      } else {
        tl
          .to('.loading__container',
            {
              duration: 1.6,
              opacity: 0,
              ease: "power1.inOut"
            },
            '<'
          )
          .to('.c-slideshow__navigation',
            {
              duration: 0.8,
              opacity: 1,
              ease: "power1.inOut"
            },
            '<'
          )
      }

    }

    fullLoadingAnimation()

  }

  // ロード完了
  window.addEventListener('load',function(){
    body.classList.remove('c-loading--start');
    body.classList.add('c-loading--completed');
    //アニメーション関数実行
    loadingAnimation();
  });
}

function customLoadingViewCansel() {
  const body = document.querySelector("body"),
  loadingConteiner = document.querySelector(".loading__container");

  loadingConteiner.classList.add('is-loaded')
  loadingConteiner.remove();
  body.classList.remove('c-loading');
  body.classList.remove('c-loading--is-loading')
  body.classList.add('c-loading--is-loaded')
}

// 初回アクセスの判定
function loadingVisitCheck() {
  if (!sessionStorage.getItem('visited')) {
    sessionStorage.setItem('visited', 'first');

    // DOM の読み込み状態で分岐
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      // ローディング処理開始
      customLoadingView();
    } else {
      document.addEventListener('DOMContentLoaded',function(){
        // ローディング処理開始
        customLoadingView();
      });
    }

    // 5秒後もローディング処理が続いている場合は強制終了
    const loadingConteiner = document.querySelector(".loading__container");
    setTimeout(() => {
      if (loadingConteiner != null) {
        customLoadingViewCansel();
      }
    }, 5000);

  } else {
    // customLoadingView();

    // DOM の読み込み状態で分岐
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      customLoadingViewCansel();
    } else {
      document.addEventListener('DOMContentLoaded', function(){
        // ローディング処理キャンセル
        customLoadingViewCansel();
      });
    }

    window.addEventListener('load',function(){
      // custom-top.js内のKVスライドショーのpauseを解除
      mvSlideshow("start");
    });
  }
}

// 関数実行
loadingVisitCheck();